<template>
  <div class="lastArticlesContainer tour-details">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>
      <v-toolbar-title class="pageTitle">
        Tour-Dokumente
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div style="padding-top: 20px; padding-bottom: 80px;" class="contentWrapper checkoutContent">

      <v-card
        class="news-card"
      >
        <v-list class="news-list">

          <v-list-item
            class="news-list__item"
            v-for="(file, index) in files"
            :key="index"
            @click="loadFile(file)"
          >

            <v-list-item-content>
              <v-list-item-title class="news-content" v-html="file.fileName"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>

    </div>


    <v-dialog persistent eager content-class="scannerDialog"
              attach=".v-application--wrap"
              v-bind:value="pdfDialog"
    >
      <v-card light class="three-color-grad pdfViewerCard">

        <v-btn
          class="pdfNewsCloseBtn closeBtn leftRounded"
          @click="closePDFViewer"
        >
          <close-btn/>
        </v-btn>

        <div class="pdf-dialog__container">

          <v-card class="pdf-dialog__viewer__wrapper">
            <vue-pdf-app v-show="pdf" class="pdf-dialog__viewer" :config="pdfConfig" :pdf="pdf"
                         @pages-rendered="pagesRendered"
            >
            </vue-pdf-app>

            <v-progress-circular v-if="!pdf"
                                 indeterminate
                                 color="red"
                                 class="pdf-progress-loader"
            />
            <div class="bottom-spacer-pdf"/>
          </v-card>
        </div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

import axios from "axios";
import CloseBtn from "@/assets/closeBtn.vue";
import VuePdfApp from "vue-pdf-app";

export default {
  name: "TourDocuments",
  components: { VuePdfApp, CloseBtn },
  data() {
    return {
      files: [],
      pdf: null,
      pdfDialog: false,
      pdfConfig: {
        toolbar: {
          toolbarViewerLeft: {
            findbar: false,
            previous: false,
            next: false
          },

          toolbarViewerMiddle: true,
          toolbarViewerRight: {
            presentationMode: false,
            openFile: false,
            viewBookmark: false,
            print: true,
            download: true
          },
        },
        secondaryToolbar: false,
        sidebar: false
      }
    }
  },
  async mounted() {
    const docResult = await axios.get('/api/tour-data/tour-documents/files')
    this.files.push(...docResult.data.map(file => {
      return {
        fileName: file.substring(file.lastIndexOf('/')+1, file.lastIndexOf('.')),
        filePath: file
      }
    }).sort((a, b) => a.fileName.localeCompare(b.fileName))
    )
  },
  methods: {
    closePDFViewer() {
      this.pdfDialog = false
      this.pdf = null
    },
    pagesRendered(pdfApp) {
      setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = "page-fit"))
    },
    goBack() {
      this.$router.go(-1)
    },
    async loadFile(file) {
      this.pdfDialog = true
      const result = await axios.post(`/api/tour-data/tour-documents/get-file`, {path: file.filePath}, {
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',

        },
        responseType: 'arraybuffer'})
      let doc = new Blob([result.data])
      const pdf = await doc.arrayBuffer()
      this.pdf = pdf
    }
  }
}
</script>

<style scoped>

</style>
